export default __webpack_public_path__ + "static/media/IMG_5132.8317e68b.jpeg";